import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const MonthlyTargetList = lazy(() => import('../Pages/MonthlyTargetList'));
const MonthlyTargetView = lazy(() => import('../Pages/MonthlyTargetView'));
const AddMonthlyTarget = lazy(() => import('../Pages/AddMonthlyTarget'));
const EditMonthlyTarget = lazy(() => import('../Pages/EditMonthlyTarget'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

function MonthlyTargetRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/business/monthly-targets"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/business/monthly-targets/list"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/business/monthly-targets/view/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <MonthlyTargetView history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />

            <Route
                exact
                path="/:lng/business/monthly-targets/add"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <AddMonthlyTarget history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />

            <Route
                exact
                path="/:lng/business/monthly-targets/edit/:slack"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <EditMonthlyTarget history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
};

export default MonthlyTargetRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
